import * as React from 'react';

export const Tos = () => (
  <>
    These terms of use are entered into by and between you and Trac
    Technologies, Inc. (“Trac”). The following terms and conditions, together
    with any documents they expressly incorporate by reference (collectively,
    “Terms of Use”), govern your access to and use of{' '}
    <a
      className="link-line"
      href="http://trac.co"
      target="_blank"
      rel="noopener noreferrer"
    >
      http://trac.co
    </a>{' '}
    (whether as a guest or a registered user), including any content,
    functionality, and services offered through the same (collectively, the
    “Website”)
    <br />
    <br />
    Please read the Terms of Use carefully before you start to use the Website.
    By using the Website, you accept and agree to be bound and abide by these
    Terms of Use and our Privacy Policy, found at{' '}
    <a
      className="link-line"
      href="http://trac.co/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
    >
      http://trac.co/privacy-policy
    </a>{' '}
    and incorporated herein by reference. If you do not want to agree to these
    Terms of Use you must not access or use the Website. By using the Website,
    you represent and warrant that you are of legal age to form a binding
    contract with Trac, and that Trac may expressly rely on such representation.
    <br />
    <br />
    Trac may revise and update these Terms of Use from time to time in its sole
    discretion. All changes are effective immediately when posted and apply to
    all access to and use of the Website thereafter. Your continued use of the
    Website following the posting of revised Terms of Use means that you accept
    and agree to the changes. You are expected to check this page frequently so
    you are aware of any changes, as they are binding on you.
    <br />
    <br />
    <br />
    <br />
    <b>1. Accessing the Website and Account Security</b>
    <br />
    <br />
    Trac reserves the right to withdraw or amend this Website, and any service
    or material Trac provides on the Website, in its sole discretion without
    notice. Trac will not be liable if for any reason all or any part of the
    Website is unavailable at any time or for any period. From time to time,
    Trac may restrict access to some parts of the Website, or the entire
    Website, to users, including registered users, as deemed necessary or
    desirable in Trac’s sole discretion. You are responsible for making all
    arrangements necessary for you to have access to the Website, and ensuring
    that all persons who access the Website through your internet connection are
    aware of these Terms of Use and comply with them.
    <br />
    <br />
    To access the Website or some of the resources it offers, you may be asked
    to provide certain registration details or other information. It is a
    condition of your use of the Website that all the information you provide on
    the Website is correct, current, and complete. You agree that all
    information you provide to register with the Website or otherwise is
    governed by our Privacy Policy, and you consent to all actions Trac takes
    with respect to your information consistent with our Privacy Policy.
    <br />
    <br />
    If you choose, or are provided with, a user name, password, or any other
    piece of information as part of Trac’s security procedures, you must treat
    such information as confidential, and you must not disclose it to any other
    person or entity. You also acknowledge that your account is personal to you
    and agree not to provide any other person with access to the Website or
    portions of it using your user name, password, or other security
    information. You agree to notify Trac immediately of any unauthorized access
    to or use of your user name or password or any other breach of security. You
    also agree to ensure that you exit from your account at the end of each
    session. You should use particular caution when accessing your account from
    a public or shared computer so that others are not able to view or record
    your password or other personal information.
    <br />
    <br />
    Trac has the right to disable any user name, password, or other identifier,
    whether chosen by you or provided by Trac, at any time in its sole
    discretion for any or no reason, including if, in Trac’s opinion, you have
    violated any provision of these Terms of Use.
    <br />
    <br />
    <br />
    <br />
    <b>2. Intellectual Property Rights</b>
    <br />
    <br />
    The Website and its entire contents, features, and functionality (including
    but not limited to all information, software, text, displays, images, video,
    and audio, and the design, selection, and arrangement thereof) are owned by
    Trac, its licensors, or other providers of such material and are protected
    by United States and international copyright, trademark, patent, trade
    secret, and other intellectual property or proprietary rights laws.
    <br />
    <br />
    These Terms of Use permit you to use the Website for your personal,
    non-commercial use only. You must not reproduce, distribute, modify, create
    derivative works of, publicly display, publicly perform, republish,
    download, store, or transmit any of the material on the Website, except as
    follows:
    <br />
    <br />
    &#8226; Your computer may temporarily store copies of such materials in RAM
    incidental to your accessing and viewing those materials.
    <br />
    &#8226; You may store files that are automatically cached by your web
    browser for display enhancement purposes.
    <br />
    &#8226; You may print or download one copy of a reasonable number of pages
    of the Website for your own personal, non-commercial use and not for further
    reproduction, publication, or distribution.
    <br />
    &#8226; If Trac provides desktop, mobile, or other applications for
    download, you may download a single copy to your computer or mobile device
    solely for your own personal, non-commercial use, provided you agree to be
    bound by any applicable end user license agreement for such applications.
    <br />
    &#8226; If Trac provides social media features with certain content, you may
    take such actions as are enabled by such features.
    <br />
    <br />
    <b>You must not:</b>
    <br />
    <br />
    &#8226; Modify copies of any materials from the Website.
    <br />
    &#8226; Use any illustrations, photographs, video or audio sequences, or any
    graphics separately from the accompanying text.
    <br />
    &#8226; Delete or alter any copyright, trademark, or other proprietary
    rights notices from copies of materials from the Website.
    <br />
    &#8226; Access or use for any commercial purposes any part of the Website or
    any services or materials available through the Website.
    <br />
    <br />
    If you print, copy, modify, download, or otherwise use or provide any other
    person with access to any part of the Website in breach of the Terms of Use,
    your right to use the Website will stop immediately and you must, at Trac’s
    option, return or destroy any copies of the materials you have made. No
    right, title, or interest in or to the Website or any content on the Website
    is transferred to you, and all rights not expressly granted are reserved by
    Trac. Any use of the Website not expressly permitted by these Terms of Use
    is a breach of these Terms of Use and may violate copyright, trademark, and
    other laws
    <br />
    <br />
    <br />
    <br />
    <b>3. Trademarks</b>
    <br />
    <br />
    Trac’s name, the TRAC trademark, TRAC logo, and all related names, logos,
    product and service names, designs, and slogans are trademarks of Trac or
    its affiliates or licensors. You must not use such marks without the prior
    written permission of Trac. All other names, logos, product and service
    names, designs, and slogans on the Website are the trademarks of their
    respective owners.
    <br />
    <br />
    <br />
    <br />
    <b>4. Prohibited Uses</b>
    <br />
    <br />
    You may use the Website only for lawful purposes and in accordance with
    these Terms of Use. You agree not to use the Website:
    <br />
    <br />
    &#8226; In any way that violates any applicable federal, state, local, or
    international law or regulation (including, without limitation, any laws
    regarding the export of data or software to and from the United States or
    other countries).
    <br />
    &#8226; For the purpose of exploiting, harming, or attempting to exploit or
    harm minors in any way by exposing them to inappropriate content, asking for
    personally identifiable information, or otherwise.
    <br />
    &#8226; To send, knowingly receive, upload, download, use, or re-use any
    material that does not comply with the Content Standards set out in these
    Terms of Use.
    <br />
    &#8226; To transmit, or procure the sending of, any advertising or
    promotional material, including any “junk mail,” “chain letter,” “spam,” or
    any other similar solicitation.
    <br />
    &#8226; To impersonate or attempt to impersonate Trac, a Trac employee,
    another user, or any other person or entity (including, without limitation,
    by using email addresses or screen names associated with any of the
    foregoing).
    <br />
    &#8226; To engage in any other conduct that restricts or inhibits anyone’s
    use or enjoyment of the Website, or which, as determined by Trac in its sole
    discretion, may harm Trac or users of the Website, or expose them to
    liability.
    <br />
    <br />
    <b>Additionally, you agree not to:</b>
    <br />
    <br />
    &#8226; Use the Website in any manner that could disable, overburden,
    damage, or impair the site or interfere with any other party’s use of the
    Website, including their ability to engage in real time activities through
    the Website.
    <br />
    &#8226; Use any robot, spider, or other automatic device, process, or means
    to access the Website for any purpose, including monitoring or copying any
    of the material on the Website.
    <br />
    &#8226; Use any manual process to monitor or copy any of the material on the
    Website, or for any other purpose not expressly authorized in these Terms of
    Use, without Trac’s prior written consent.
    <br />
    &#8226; Use any device, software, or routine that interferes with the proper
    working of the Website.
    <br />
    &#8226; Introduce any viruses, Trojan horses, worms, logic bombs, or other
    material that is malicious or technologically harmful.
    <br />
    &#8226; Attempt to gain unauthorized access to, interfere with, damage, or
    disrupt any parts of the Website, the server on which the Website is stored,
    or any server, computer, or database connected to the Website.
    <br />
    &#8226; Attack the Website via a denial-of-service attack or a distributed
    denial-of-service attack.
    <br />
    &#8226; Otherwise attempt to interfere with the proper working of the
    Website.
    <br />
    <br />
    <br />
    <br />
    <b>5. User Contributions</b>
    <br />
    <br />
    The Website may contain message boards, chat rooms, personal web pages or
    profiles, forums, bulletin boards, and other interactive features
    (collectively, “Interactive Services”) that allow users to post, submit,
    publish, display, or transmit to other users or other persons content or
    materials (collectively, “User Contributions”) on or through the Website.
    All User Contributions must comply with the Content Standards set out in
    these Terms of Use.
    <br />
    <br />
    Any User Contribution you post to the site will be considered
    non-confidential and non-proprietary. By providing any User Contribution on
    the Website, you grant Trac and its affiliates and service providers, and
    each of their and our respective licensees, successors, and assigns the
    right to use, reproduce, modify, perform, display, distribute, and otherwise
    disclose to third parties any such material for any purpose.
    <br />
    <br />
    <b>You represent and warrant that:</b>
    <br />
    <br />
    &#8226; You own or control all rights in and to the User Contributions and
    have the right to grant the license granted above to Trac and its affiliates
    and service providers, and each of their and our respective licensees,
    successors, and assigns.
    <br />
    &#8226; All of your User Contributions do and will comply with these Terms
    of Use.
    <br />
    <br />
    You understand and acknowledge that you are responsible for any User
    Contributions you submit or contribute, and you, not Trac, have full
    responsibility for such content, including its legality, reliability,
    accuracy, and appropriateness. Trac is not responsible or liable to any
    third party for the content or accuracy of any User Contributions posted by
    you or any other user of the Website.
    <br />
    <br />
    <br />
    <br />
    <b>6. Monitoring and Enforcement; Termination</b>
    <br />
    <br />
    <b>Trac has the right to:</b>
    <br />
    <br />
    &#8226; Remove or refuse to post any User Contributions for any or no reason
    in Trac’s sole discretion.
    <br />
    &#8226; Take any action with respect to any User Contribution that Trac
    deems necessary or appropriate in its sole discretion, including if Trac
    believes that such User Contribution violates the Terms of Use, including
    the Content Standards, infringes any intellectual property right or other
    right of any person or entity, threatens the personal safety of users of the
    Website or the public, or could create liability for Trac.
    <br />
    &#8226; Disclose your identity or other information about you to any third
    party who claims that material posted by you violates their rights,
    including their intellectual property rights or their right to privacy.
    <br />
    &#8226; Take appropriate legal action, including without limitation,
    referral to law enforcement, for any illegal or unauthorized use of the
    Website.
    <br />
    &#8226; Terminate or suspend your access to all or part of the Website for
    any or no reason, including without limitation, any violation of these Terms
    of Use.
    <br />
    <br />
    Without limiting the foregoing, Trac has the right to cooperate fully with
    any law enforcement authorities or court order requesting or directing Trac
    to disclose the identity or other information of anyone posting any
    materials on or through the Website. YOU WAIVE AND HOLD HARMLESS TRAC AND
    ITS AFFILIATES, LICENSEES, AND SERVICE PROVIDERS FROM ANY CLAIMS RESULTING
    FROM ANY ACTION TAKEN BY TRAC AND ANY OF THE FOREGOING PARTIES DURING, OR
    TAKEN AS A CONSEQUENCE OF, INVESTIGATIONS BY EITHER TRAC AND SUCH PARTIES OR
    LAW ENFORCEMENT AUTHORITIES.
    <br />
    <br />
    However, you understand that Trac does not undertake to review all material
    before it is posted on the Website, and cannot ensure prompt removal of
    objectionable material after it has been posted. Accordingly, Trac assumes
    no liability for any action or inaction regarding transmissions,
    communications, or content provided by any user or third party. Trac has no
    liability or responsibility to anyone for performance or nonperformance of
    the activities described in this section.
    <br />
    <br />
    <br />
    <br />
    <b>7. Content Standards</b>
    <br />
    <br />
    These content standards apply to any and all User Contributions and use of
    Interactive Services. User Contributions must in their entirety comply with
    all applicable federal, state, local, and international laws and
    regulations. Without limiting the foregoing, User Contributions must not:
    <br />
    <br />
    &#8226; Contain any material that is defamatory, obscene, indecent, abusive,
    offensive, harassing, violent, hateful, inflammatory, or otherwise
    objectionable.
    <br />
    &#8226; Promote sexually explicit or pornographic material, violence, or
    discrimination based on race, sex, religion, nationality, disability, sexual
    orientation, or age.
    <br />
    &#8226; Infringe any patent, trademark, trade secret, copyright, or other
    intellectual property or other rights of any other person.
    <br />
    &#8226; Violate the legal rights (including the rights of publicity and
    privacy) of others or contain any material that could give rise to any civil
    or criminal liability under applicable laws or regulations or that otherwise
    may be in conflict with these Terms of Use and our Privacy Policy.
    <br />
    &#8226; Be likely to deceive any person.
    <br />
    &#8226; Promote any illegal activity, or advocate, promote, or assist any
    unlawful act.
    <br />
    &#8226; Cause annoyance, inconvenience, or needless anxiety or be likely to
    upset, embarrass, alarm, or annoy any other person.
    <br />
    &#8226; Impersonate any person, or misrepresent your identity or affiliation
    with any person or organization.
    <br />
    &#8226; Involve commercial activities or sales, such as contests,
    sweepstakes, and other sales promotions, barter, or advertising.
    <br />
    &#8226; Give the impression that they emanate from or are endorsed by Trac
    or any other person or entity, if this is not the case.
    <br />
    <br />
    <br />
    <br />
    <b>8. Copyright Infringement</b>
    <br />
    <br />
    Trac takes claims of copyright infringement seriously. Trac will respond to
    notices of alleged copyright infringement that comply with applicable law.
    If you believe any materials accessible on or from the Website infringe your
    copyright, you may request removal of those materials (or access to them)
    from the Website by submitting written notification to our copyright agent
    designated below. In accordance with the Online Copyright Infringement
    Liability Limitation Act of the Digital Millennium Copyright Act (17 U.S.C.
    § 512) (“DMCA”), the written notice (the “DMCA Notice”) must include
    substantially the following:
    <br />
    <br />
    &#8226; Your physical or electronic signature.
    <br />
    &#8226; Identification of the copyrighted work you believe to have been
    infringed or, if the claim involves multiple works on the Website, a
    representative list of such works.
    <br />
    &#8226; Identification of the material you believe to be infringing in a
    sufficiently precise manner to allow Trac to locate that material.
    <br />
    &#8226; Adequate information by which Trac can contact you (including your
    name, postal address, telephone number, and, if available, email address).
    <br />
    &#8226; A statement that you have a good faith belief that use of the
    copyrighted material is not authorized by the copyright owner, its agent, or
    the law.
    <br />
    &#8226; A statement that the information in the written notice is accurate.
    <br />
    &#8226; A statement, under penalty of perjury, that you are authorized to
    act on behalf of the copyright owner.
    <br />
    <br />
    Trac’s designated copyright agent to receive DMCA Notices is:
    <br />
    <br />
    Trac Technologies, Inc.
    <br />
    P.O. Box 1511
    <br />
    Santa Monica, CA 90406
    <br />
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:copyright@trac.co"
    >
      copyright@trac.co
    </a>
    <br />
    <br />
    If you fail to comply with all of the requirements of Section 512(c)(3) of
    the DMCA, your DMCA Notice may not be effective. Please be aware that if you
    knowingly materially misrepresent that material or activity on the Website
    is infringing your copyright, you may be held liable for damages (including
    costs and attorneys’ fees) under Section 512(f) of the DMCA.
    <br />
    <br />
    If you believe that material you posted on the Website was removed or access
    to it was disabled by mistake or misidentification, you may file a counter
    notification with Trac (a “Counter Notice”) by submitting written
    notification to Trac’s copyright agent designated above. Pursuant to the
    DMCA, the Counter Notice must include substantially the following:
    <br />
    <br />
    &#8226; Your physical or electronic signature.
    <br />
    &#8226; An identification of the material that has been removed or to which
    access has been disabled and the location at which the material appeared
    before it was removed or access disabled.
    <br />
    &#8226; Adequate information by which Trac can contact you (including your
    name, postal address, telephone number, and, if available, email address).
    <br />
    &#8226; A statement under penalty of perjury by you that you have a good
    faith belief that the material identified above was removed or disabled as a
    result of a mistake or misidentification of the material to be removed or
    disabled.
    <br />
    &#8226; A statement that you will consent to the jurisdiction of the Federal
    District Court for the judicial district in which your address is located
    (or if you reside outside the United States for any judicial district in
    which the Website may be found) and that you will accept service from the
    person (or an agent of that person) who provided the Website with the
    complaint at issue.
    <br />
    <br />
    The DMCA allows Trac to restore the removed content if the party filing the
    original DMCA Notice does not file a court action against you within ten
    business days of receiving the copy of your Counter Notice.
    <br />
    <br />
    Please be aware that if you knowingly materially misrepresent that material
    or activity on the Website was removed or disabled by mistake or
    misidentification, you may be held liable for damages (including costs and
    attorneys’ fees) under Section 512(f) of the DMCA.
    <br />
    <br />
    <br />
    <br />
    <b>9. Reliance on Information Posted</b>
    <br />
    <br />
    The information presented on or through the Website is made available solely
    for general information purposes. Trac does not warrant the accuracy,
    completeness, or usefulness of this information. Any reliance you place on
    such information is strictly at your own risk. Trac disclaims all liability
    and responsibility arising from any reliance placed on such materials by you
    or any other visitor to the Website, or by anyone who may be informed of any
    of its contents.
    <br />
    <br />
    The Website may include content provided by third parties, including
    materials provided by other users, bloggers, and third-party licensors,
    syndicators, aggregators, and/or reporting services. All statements and/or
    opinions expressed in these materials, and all articles and responses to
    questions and other content, other than the content provided by Trac, are
    solely the opinions and the responsibility of the person or entity providing
    those materials. These materials do not necessarily reflect the opinion of
    Trac. Trac is not responsible, or liable to you or any third party, for the
    content or accuracy of any materials provided by any third parties.
    <br />
    <br />
    <br />
    <br />
    <b>10. Changes to the Website</b>
    <br />
    <br />
    Trac may update the content on this Website from time to time, but its
    content is not necessarily complete or up-to-date. Any of the material on
    the Website may be out of date at any given time, and Trac is under no
    obligation to update such material.
    <br />
    <br />
    <br />
    <br />
    <b>11. Online Purchases and Other Terms and Conditions</b>
    <br />
    <br />
    All purchases through the Website or other transactions for the sale of
    goods or services formed through the Website, or resulting from visits made
    by you, are governed by these Terms of Use. Additional terms and conditions
    may also apply to specific portions, services, or features of the Website.
    All such additional terms and conditions are hereby incorporated by this
    reference into these Terms of Use.
    <br />
    <br />
    Prices and availability of goods are subject to change. Trac will only
    confirm the availability and price of an item when you actually place your
    order. There may be instances in which an item listed on the Website may not
    be available, the offer on the Website may have been misstated, or an item
    may be mispriced on the Website. Accordingly, Trac reserves the right to
    cancel your order and refund your purchase. Likewise, please note that
    Trac’s order confirmation to you does not signify Trac’s acceptance of your
    order, nor does it constitute confirmation of Trac’s offer to sell. At any
    time after receipt of your order, Trac may accept, decline, or place
    quantity or other limits on your order for any reason.
    <br />
    <br />
    The products offered for sale on the Website are made-to-order. All sales
    are considered final. If you would like to modify or cancel an order, please
    email{' '}
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:support@trac.co"
    >
      support@trac.co
    </a>{' '}
    within 24 hours of placing your order. However, Trac cannot guarantee the
    ability to cancel your order if it has already been processed. There are
    absolutely no returns on product purchased except for defective or damaged
    product. If an order arrives with damaged, defective, or missing items,
    please email{' '}
    <a
      className="link-line"
      target="_blank"
      rel="noopener noreferrer"
      href="mailto:support@trac.co"
    >
      support@trac.co
    </a>{' '}
    within 10 days of delivery. Trac will review the information and contact you
    to discuss next steps.
    <br />
    <br />
    <br />
    <br />
    <b>12. Third-Party Integrations:</b>
    <br />
    <br />
    During use of the Website, you may enter into correspondence with, purchase
    goods and/or services from, or participate in promotions of advertisers or
    sponsors showing their goods and/or services through the Website. Any such
    activities, and any terms, conditions, warranties or representations
    associated with such activities, are solely between you and the applicable
    third party. Trac will have no liability, obligation, or responsibility for
    any such correspondence, purchase or promotion between you and any such
    third party. Trac does not endorse any sites that are linked through the
    Website. Trac provides these links to you only as a matter of convenience,
    and in no event will Trac be responsible for any content, products, or other
    materials available from such sites.
    <br />
    <br />
    Trac uses third-party integrations for purposes of operating the Website and
    providing services. Use of these integrations is expressly subject to the
    terms and conditions established by such third party, and you agree to be
    bound by the same. Without limiting the generality of the foregoing:
    <br />
    <br />
    &#8226; Any use of the{' '}
    <a
      className="link-line"
      href="https://www.sendwyre.com/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Wyre
    </a>{' '}
    payment service is subject to its{' '}
    <a
      className="link-line"
      href="https://www.sendwyre.com/user-agreement/"
      target="_blank"
      rel="noopener noreferrer"
    >
      User Agreement
    </a>{' '}
    and{' '}
    <a
      className="link-line"
      href="https://www.sendwyre.com/privacy-policy/"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>
    .
    <br />
    <br />
    <br />
    <br />
    <b>13. Links from the Website</b>
    <br />
    <br />
    If the Website contains links to other sites and resources provided by third
    parties, these links and resources are provided for your convenience only.
    This includes links contained in advertisements, including banner
    advertisements and sponsored links. Trac has no control over the contents of
    those sites or resources, and accepts no responsibility for them or for any
    loss or damage that may arise from your use of them. If you decide to access
    any of the third-party websites linked to this Website, you do so entirely
    at your own risk and subject to the terms and conditions of use for such
    websites.
    <br />
    <br />
    <br />
    <br />
    <b>14. Geographic Restrictions</b>
    <br />
    <br />
    The owner of the Website is based in the state of California in the United
    States. Trac provides the Website for use only by persons located in the
    United States. Trac makes no claims that the Website or any of its content
    is accessible or appropriate outside of the United States. Access to the
    Website may not be legal by certain persons or in certain countries. If you
    access the Website from outside the United States, you do so on your own
    initiative and are responsible for compliance with local laws.
    <br />
    <br />
    <br />
    <br />
    <b>15. Disclaimer of Warranties</b>
    <br />
    <br />
    You understand that Trac cannot and does not guarantee or warrant that files
    available for downloading from the internet or the Website will be free of
    viruses or other destructive code. You are responsible for implementing
    sufficient procedures and checkpoints to satisfy your particular
    requirements for anti-virus protection and accuracy of data input and
    output, and for maintaining a means external to our site for any
    reconstruction of any lost data. TO THE FULLEST EXTENT PROVIDED BY LAW, TRAC
    WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED
    DENIAL-OF-SERVICE ATTACK, VIRUSES, OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL
    THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA, OR OTHER
    PROPRIETARY MATERIAL DUE TO YOUR USE OF THE WEBSITE OR ANY SERVICES OR ITEMS
    OBTAINED THROUGH THE WEBSITE OR TO YOUR DOWNLOADING OF ANY MATERIAL POSTED
    ON IT, OR ON ANY WEBSITE LINKED TO IT.
    <br />
    <br />
    YOUR USE OF THE WEBSITE, ITS CONTENT, AND ANY SERVICES OR ITEMS OBTAINED
    THROUGH THE WEBSITE IS AT YOUR OWN RISK. THE WEBSITE, ITS CONTENT, AND ANY
    SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE ARE PROVIDED ON AN “AS IS”
    AND “AS AVAILABLE” BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS
    OR IMPLIED. NEITHER TRAC NOR ANY PERSON ASSOCIATED WITH TRAC MAKES ANY
    WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY,
    RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE WEBSITE. WITHOUT
    LIMITING THE FOREGOING, NEITHER TRAC NOR ANYONE ASSOCIATED WITH TRAC
    REPRESENTS OR WARRANTS THAT THE WEBSITE, ITS CONTENT, OR ANY SERVICES OR
    ITEMS OBTAINED THROUGH THE WEBSITE WILL BE ACCURATE, RELIABLE, ERROR-FREE,
    OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE
    SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL
    COMPONENTS, OR THAT THE WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH
    THE WEBSITE WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.
    <br />
    <br />
    TO THE FULLEST EXTENT PROVIDED BY LAW, TRAC HEREBY DISCLAIMS ALL WARRANTIES
    OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING
    BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT, AND
    FITNESS FOR PARTICULAR PURPOSE.
    <br />
    <br />
    THE FOREGOING DOES NOT AFFECT ANY WARRANTIES THAT CANNOT BE EXCLUDED OR
    LIMITED UNDER APPLICABLE LAW.
    <br />
    <br />
    <br />
    <br />
    <b>16. Limitation on Liability</b>
    <br />
    <br />
    TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL TRAC, ITS
    AFFILIATES, OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS,
    OFFICERS, OR DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL
    THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR USE, OR INABILITY TO USE,
    THE WEBSITE, ANY WEBSITES LINKED TO IT, ANY CONTENT ON THE WEBSITE OR SUCH
    OTHER WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL,
    CONSEQUENTIAL, OR PUNITIVE DAMAGES, INCLUDING BUT NOT LIMITED TO, PERSONAL
    INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS OF
    PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF
    GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY TORT (INCLUDING NEGLIGENCE),
    BREACH OF CONTRACT, OR OTHERWISE, EVEN IF FORESEEABLE.
    <br />
    <br />
    THE FOREGOING DOES NOT AFFECT ANY LIABILITY THAT CANNOT BE EXCLUDED OR
    LIMITED UNDER APPLICABLE LAW.
    <br />
    <br />
    <br />
    <br />
    <b>17. Indemnification</b>
    <br />
    <br />
    You agree to defend, indemnify, and hold harmless Trac, its affiliates,
    licensors, and service providers, and its and their respective officers,
    directors, employees, contractors, agents, licensors, suppliers, successors,
    and assigns from and against any claims, liabilities, damages, judgments,
    awards, losses, costs, expenses, or fees (including reasonable attorneys’
    fees) arising out of or relating to your violation of these Terms of Use or
    your use of the Website, including, but not limited to, your User
    Contributions, any use of the Website’s content, services, and products
    other than as expressly authorized in these Terms of Use, or your use of any
    information obtained from the Website.
    <br />
    <br />
    <br />
    <br />
    <b>18. Governing Law and Arbitration</b>
    <br />
    <br />
    All matters relating to the Website and these Terms of Use, and any dispute
    or claim arising therefrom or related thereto (in each case, including
    non-contractual disputes or claims), shall be governed by and construed in
    accordance with the internal laws of the state of California without giving
    effect to any choice or conflict of law provision or rule (whether of the
    state of California or any other jurisdiction).
    <br />
    <br />
    Any controversy or claim between the parties arising out of or relating to
    these Terms of Use or your use of the Website (including the formation,
    validity, construction, scope, performance, breach, and or cancellation of
    this arbitration clause), will be resolved through confidential and binding
    arbitration in accordance with the JAMS Streamlined Arbitration Rules and
    Procedures with Optional Appeal under the laws of the state of California
    without regard to conflicts of laws principles. Notwithstanding the
    foregoing mandatory arbitration provisions: (i) except as otherwise provided
    herein, Trac may seek, and any state or federal court of competent
    jurisdiction is authorized to provide, interim injunctive or other equitable
    relief in aid of arbitration of any claim between the parties pursuant to
    this agreement; (ii) if you fail or refuse to participate in the
    arbitration, including the payment of your share of the arbitration fees,
    Trac has the authority (but not the obligation) to file suit against you as
    a non-participating party in any state or federal court located in Los
    Angeles, California; and (iii) if Trac is sued or joined in a third-party
    action relative to Your Content or your use of the Service, Trac will be
    entitled to pursue any related counterclaims, crossclaims, or third-party
    claims against you in connection with such action, and you hereby consent to
    the jurisdiction of the court and forum where the action is pending.
    <br />
    <br />
    <br />
    <br />
    <b>19. Waiver and Severability</b>
    <br />
    <br />
    No waiver by Trac of any term or condition set out in these Terms of Use
    shall be deemed a further or continuing waiver of such term or condition or
    a waiver of any other term or condition, and any failure of Trac to assert a
    right or provision under these Terms of Use shall not constitute a waiver of
    such right or provision.
    <br />
    <br />
    If any provision of these Terms of Use is held by a court or other tribunal
    of competent jurisdiction to be invalid, illegal, or unenforceable for any
    reason, such provision shall be eliminated or limited to the minimum extent
    such that the remaining provisions of the Terms of Use will continue in full
    force and effect.
    <br />
    <br />
    <br />
    <br />
    <b>20. Your Comments and Concerns</b>
    <br />
    <br />
    Please send any feedback, comments, requests for technical support, and
    other communications relating to the Website to:{' '}
    <a
      className="link-line"
      href="mailto:support@trac.co"
      target="_blank"
      rel="noopener noreferrer"
    >
      support@trac.co
    </a>
    .
  </>
);

export default Tos;
